import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { InsaCronService } from "../../../../../insa-services";
import { ProcessJobDetails } from "../../../../../insa-models";

@Component({
  selector: "edit-process",
  template: require("./edit-process.component.html")
})

export class EditProcessComponent implements OnInit {

  _activityID: number = null;
  @Input() set processDetails(activityData: any) {
    this._activityID = activityData;
    console.log("process input activityID --> " + this._activityID);

  };
  @Input() editProcessForm: FormGroup;

  _details: ProcessJobDetails = new ProcessJobDetails();
  @Input() set bla(det: ProcessJobDetails) {
    this._details = det;
  };

  processActivityID: number = null;
  processProcessID: number = null;

  processData: ProcessJobDetails = new ProcessJobDetails(); 

  private processes: any = [];

  constructor(private _insaChronosService: InsaCronService) { }


  ngOnInit() {
    console.log("OnInit");
    this._insaChronosService.getProcesses().subscribe((data: any) => {
      this.processes = data;
    });
    if(this.processes){
      if (this._activityID !== null && this._activityID !== undefined) {
        this._insaChronosService.getProcessById(this._activityID).subscribe((p: any) => {
          this.processData = p;
        });
      }
      else{
        this.processData = this._details;
        console.log("ProcesData - Activity null --> ", this.processData);
      }
    }

  }

}



// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-job/insa-activities-detail/process-job-details/edit-process.component.ts